import { WidgetProps } from '@rjsf/utils';
import { useCallback } from 'react';
import injectSheet, { ClassNameMap } from 'react-jss';

import { ProseList } from '@stratumn/atomic';
import styles from './checkboxesWidget.style';
import { KeyValue } from '@/components/ui/keyValue/keyValue';

type Props = {
  classes: ClassNameMap<string>;
} & WidgetProps;

export const CheckboxesWidget = (props: Props) => {
  const { enumOptions } = props.options;

  const getCheckedItems = useCallback(() => {
    if (!Array.isArray(props.value)) return [];

    const enumOptions = props.options.enumOptions;

    if (enumOptions && Array.isArray(enumOptions) && enumOptions.length > 0) {
      return (
        enumOptions
          ?.filter(
            option => props.value.indexOf(option.value) !== -1 && option.label
          )
          ?.map(option => option.label) ?? []
      );
    }

    return (props.value as string[]) ?? [];
  }, [enumOptions, props.value]);

  const options = getCheckedItems();

  if (options.length === 0) {
    return <></>;
  }

  const hasGDPR = props.schema.title === 'GDPR regulation';

  return (
    <KeyValue title={props.schema.title} dataCyName={props.name}>
      {!hasGDPR ? <ProseList items={options} /> : <> {options?.[0]} </>}
    </KeyValue>
  );
};

export default injectSheet(styles)(CheckboxesWidget);
